import {createAction} from '@ngrx/store';

export const setParameterList = '[Parameter] setParameterList';
export const fetchParameterList = '[Parameter] fetchParameterList';
export const addParameterList = '[Parameter] addParameterList';
export const getByKeyParameterList = '[Parameter] getByKeyParameterList';
export const removeParameterList = '[Parameter] removeParameterList'
export const updateParameterList = '[Parameter] updateParameterList';

export const setParameterListAction = createAction(setParameterList, (parameterList) => {
  return {payload: parameterList}
});

export const fetchParameterListAction = createAction(fetchParameterList);

export const getByKeyParameterListAction = createAction(getByKeyParameterList, (key) => {
  return {payload: key}
});

export const addParameterListAction = createAction(addParameterList, (parameter) => {
  return {payload: parameter}
});

export const updateParameterListAction = createAction(
  updateParameterList,
  (parameter) => {
    return {payload: parameter}
  });

export const removeParameterListAction = createAction(
  removeParameterList, (parameter) => {
    return {payload: parameter}
  });
